import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Etiquette } from './components/Etiquette';
import { Screening } from './components/Screening';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Members } from './components/Members';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-ink" data-id="element-0">
      <Navigation data-id="element-1" />
      <Hero data-id="element-2" />
      <About data-id="element-3" />
      <Services data-id="element-4" />
      <Etiquette data-id="element-5" />
      <Screening data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FAQ data-id="element-8" />
      <Members data-id="element-9" />
      <Contact data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}